export const INCOME_ACCOUNT_TYPE = "הכנסה" as const;
export const INCOMES_PATH = "/incomes";
export const INCOMES_BREADCRUMB = { ledger: "כרטסות", list: "הכנסות" } as const;
export const INCOMES_STRUCTURE_CRUMBS = {
  search: "הגדרת מבנה חיפוש",
  browse: "הגדרת מבנה דפדוף",
} as const;
export const SEARCH_TABLE_STYLE = {
  backgroundColor: "rgb(35, 48, 68)",
  padding: 5,
  marginButton: 20,
} as const;
